import {Card} from 'primereact/card';
import {Dialog} from 'primereact/dialog';
import {TabPanel, TabView} from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import BannerComponent from '../components/BannerComponent';
import DivContainer from '../components/DivContainer';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputNumberComponent from '../components/inputs/InputNumberComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import LimitModel from '../model/LimitModel';
import AccountService from '../services/AccountService';
import CardService from '../services/CardService';
import CardAgreementTermDialog from './CardAgreementTermDialog';

class CardManageDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.accountService = new AccountService();
        this.state = {
            element: new LimitModel(),
            viewMode: this.props.viewMode,
            activeIndex: !isNaN(props.activeIndex) ? props.activeIndex : 0,
            agreementTermDialog: false,
            selectedSelectableItem: undefined,
            acceptedTermsList: [],
        };
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        if (!prevProps.visible && this.props.visible) {
            this.setElement();
        }
        if (prevProps.activeIndex !== this.props.activeIndex && !prevProps.visible && this.props.visible) {
            this.setState({activeIndex: this.props.activeIndex});
        }
    }

    initBeforeSetElement() {}

    handleTabChange(e) {
        if (this.props.activeIndex === null || this.props.activeIndex === undefined || isNaN(this.props.activeIndex)) {
            this.setState({
                activeIndex: e.index,
            });
        }
    }

    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container card-manage-footer'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={this.state.viewMode === 'DELETE' ? 'button cancel-button red' : 'button cancel-button white'}
                    handleClick={this.props.onHide}
                />
                <ActionButton
                    label={t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
            </div>
        );
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer
                    colClass={`col-12 ${
                        this.props.activeIndex === undefined || this.props.activeIndex === null
                            ? 'transaction-dialog-header'
                            : 'cards-dialog-header'
                    }`}
                >
                    <DivContainer colClass='col-12'>
                        <label>
                            {this.props.activeIndex === undefined || this.props.activeIndex === null
                                ? `${t('cards.editHeader')}`
                                : `${t('details.editButton')}: ${
                                      this.props.activeIndex === 0
                                          ? t('cards.petrolHeader')
                                          : this.props.activeIndex === 1
                                          ? t('cards.serviceHeader')
                                          : this.props.activeIndex === 2
                                          ? t('cards.productsHeader')
                                          : ''
                                  }`}
                        </label>
                    </DivContainer>
                </DivContainer>
                {this.props.activeIndex === undefined || this.props.activeIndex === null ? (
                    <DivContainer colClass='col-12 sub-dialog-header'>
                        <DivContainer colClass='col-12'>
                            <label className='label-card-manage-description'>{t('cards.manageDesc')}</label>
                        </DivContainer>
                    </DivContainer>
                ) : null}
            </React.Fragment>
        );
    }

    updateElement(data) {
        this.setState(
            {
                element: LimitModel.copy(data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        } else if (this.props.cards && this.props.cards.length >= 1) {
            this.blockUi();
            this.service
                .get(this.props.cards[0])
                .then((res) => {
                    this.updateElement(res);
                    this.unblockUi();
                })
                .catch((err) => {
                    this.showErrorMessage('cards.manageGroupError');
                    this.unblockUi();
                });
        } else {
            this.initAfterSetElement();
        }
    }

    getContainerListName() {
        return 'card-list-container';
    }

    getAddSucces() {
        return 'Osoba kontaktowa została utworzona';
    }

    getUpdateSucces() {
        const {t} = this.props;
        return t('cards.cardsUpdateSuccess');
    }

    createOrUpdate() {
        const {activeIndex} = this.props;
        const {element} = this.state;
        const request = element;
        request.cards = this.props.cards;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (activeIndex === 0) {
                this.service
                    .updateFuelsLimit(request)
                    .then((response) => {
                        this.createOrUpdateResult(true, response);
                    })
                    .catch((err) => {
                        this.createOrUpdateResult(false, err);
                    });
            } else if (activeIndex === 1) {
                this.service
                    .updateServicesLimit(request)
                    .then((response) => {
                        this.createOrUpdateResult(true, response);
                    })
                    .catch((err) => {
                        this.createOrUpdateResult(false, err);
                    });
            } else if (activeIndex === 2) {
                this.service
                    .updateProductsLimit(request)
                    .then((response) => {
                        this.createOrUpdateResult(true, response);
                    })
                    .catch((err) => {
                        this.createOrUpdateResult(false, err);
                    });
            } else {
                this.service
                    .updateMultipleCards(request)
                    .then((response) => {
                        this.createOrUpdateResult(true, response);
                    })
                    .catch((err) => {
                        this.createOrUpdateResult(false, err);
                    });
            }
        }
    }

    createOrUpdateResult(success, response) {
        const {t} = this.props;
        if (success) {
            this.blockUi();
            if (this.props.afterSave) {
                this.persistMessage('success', '', this.getUpdateSucces(response));
                this.unblockUi();
                this.props.afterSave();
            }
            if (this.props.handleSuccess) {
                this.props.handleSuccess(response);
            }
        } else {
            if (this.props.afterSave) {
                this.persistMessage('error', '', t('error.cardDataUpdateError'));
                this.unblockUi();
                this.props.afterSave();
            }
            if (this.props.handleError) {
                this.props.handleError();
            }
        }
    }

    render() {
        const {className, id, key, name, onHide, visible, style} = this.props;
        return (
            <div>
                <Dialog
                    ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                    header={this.renderHeader()}
                    visible={visible && !this.state.agreementTermDialog}
                    className={className}
                    style={style}
                    key={`${key ? key : id ? id : name}-dialog`}
                    onHide={() => (onHide ? onHide() : null)}
                    closable={this.state.closable}
                >
                    {this.state.loading ? null : (
                        <Card footer={this.renderFooter()}>
                            <form onSubmit={this.handleFormSubmit} noValidate onKeyDown={(e) => this.onKeyDown(e)}>
                                {this.renderDetails()}
                            </form>
                        </Card>
                    )}
                </Dialog>
                {this.state.selectedSelectableItem ? (
                    <CardAgreementTermDialog
                        id={`agreement-term-dialog`}
                        ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                        selectedProductItem={this.state.selectedSelectableItem}
                        selectedPetrolFleetGroups={this.state.element.petrols}
                        visible={this.state.agreementTermDialog}
                        blockUi={this.props.blockUi}
                        unblockUi={this.props.unblockUi}
                        showMessage={this.props.showMessage}
                        resizable={true}
                        className='agreement-term-dialog'
                        key={`agreement-term-dialog`}
                        handleReject={() => {}}
                        onHide={(e) => {
                            this.setState((prevState) => {
                                let p = this.state.selectedSelectableItem !== undefined ? this.state.selectedSelectableItem : 'ALL';
                                let allAgreementTermsAccepted = true;
                                this.state.element.petrols
                                    .filter((el) => el.agreementTermPetraId !== null)
                                    .forEach(
                                        (el) =>
                                            (allAgreementTermsAccepted =
                                                allAgreementTermsAccepted &&
                                                this.authService.isProductAgreementTermAccepted(el.agreementTermPetraId))
                                    );

                                const updatedElements = prevState.element.petrols.map((item) => {
                                    //jesli nie byl zaznaczony all, tylko cos innego
                                    if (
                                        p.name !== 'ALL' &&
                                        p.selected === true        
                                    ) { 
                                        if(!this.authService.isProductAgreementTermAccepted(item.agreementTermPetraId)){
                                        //i zaznaczony checkbox ma przypisany regulamin do akceptacji
                                        if (item.name === p.name && item.selected === true) {    
                                            //to odznacz ten przycisk skoro user nie zaakceptowal regulaminu
                                            return {...item, selected: false};
                                        }
                                        if (item.name === 'ALL' && item.selected === true) {
                                            //to odznacz ten przycisk skoro user nie zaakceptowal regulaminu
                                            return {...item, selected: false};
                                        }
                                    }
                                    if(this.authService.isProductAgreementTermAccepted(item.agreementTermPetraId)){
                                        //i zaznaczony checkbox ma przypisany regulamin do akceptacji
                                        if (item.name === p.name && item.selected === true) {
                                            //to zaznacz ten przycisk skoro user  zaakceptowal regulamin
                                            return {...item, selected: true};
                                        }
                                        if (item.name === 'ALL' && item.selected === true) {
                                            //to zaznacz ten przycisk skoro user  zaakceptowal regulamin
                                            return {...item, selected: true};
                                        }
                                    }
                                       
                                    }
                                    //jesli user zaznaczyl all i dla danego checkboxa jest przypisany regulamin
                                    if (p.name === 'ALL' && item.selected === true) { 
                                        ///  let checkedData=  this.checkX(item);
                                        let checkIfItemAgreementsAccepted = allAgreementTermsAccepted; //this.checkOnlyAgreementAcceptation(item);

                                        //jesli zaznaczono all
                                        if (item.name === 'ALL' && item.selected === true) {
                                            if (checkIfItemAgreementsAccepted) {
                                                return {...item, selected: true};
                                            } else {
                                                //odznacz all
                                                return {...item, selected: false};
                                            }
                                        }
                                        if (item.name !== 'ALL' && item.selected === true && item.agreementTermPetraId !== null) {
                                            if (this.authService.isProductAgreementTermAccepted(item.agreementTermPetraId)) {
                                                return {...item, selected: true};
                                            } else {
                                                //odznacz all
                                                return {...item, selected: false};
                                            }
                                        }
                                        //jesli zaznaczono inny item do ktorego przypisany jest regulamin
                                    }
                                    if (item.name !== 'ALL' && item.selected === true && item.agreementTermFileName !== null) {
                                        if (p.name === item.name) {
                                            return {...item, selected: false};
                                        }
                                        //odznacz go
                                    }
                                    return item;
                                });
                                return {
                                    agreementTermDialog: false,
                                    selectedSelectableItem: undefined,
                                    element: {
                                        ...prevState.element,
                                        petrols: updatedElements,
                                    },
                                };
                            });
                        }}
                        closable={false}
                    ></CardAgreementTermDialog>
                ) : null}
            </div>
        );
    }

    checkIfAgreementTermIsAlreadyAccepted(product) {
        const {t} = this.props;
        let listOfAgreementTermFileNamesAll = this.state.element['petrols']
            .filter((el) => el.agreementTermPetraId !== null)
            .map((el) => el.agreementTermPetraId);
        if (
            listOfAgreementTermFileNamesAll.includes(product.agreementTermPetraId) &&
            !this.authService.isProductAgreementTermAccepted(product.agreementTermPetraId)
        ) {
            this.accountService
                .isAgreementTermAccepted(product.agreementTermPetraId)
                .then((result) => {
                    if (result === false) {
                        console.log('checkIfAgreementTermIsAlreadyAccepted', product);
                        this.unblockUi(
                            this.setState({
                                agreementTermDialog: true,
                                selectedSelectableItem: product,
                            })
                        );
                    }
                })
                .catch(() => {
                    this.unblockUi();
                    this.showErrorMessage(t('error.isAgreementTermAcceptedError'));
                });
        }
        //TODO
        if (product.name === 'ALL') {
            listOfAgreementTermFileNamesAll.forEach((element) => {
                this.accountService
                    .isAgreementTermAccepted(element)
                    .then((result) => {
                        if (result === false) {
                            this.unblockUi(
                                this.setState({
                                    agreementTermDialog: true,
                                    selectedSelectableItem: product,
                                })
                            );
                        }
                    })
                    .catch(() => {
                        this.unblockUi();
                        this.showErrorMessage(t('error.isAgreementTermAcceptedError'));
                    });
            });
        }
    }

    renderItems(listName) {
        const {t} = this.props;
        let allSelected = false;
        if (this.state.element[listName] && this.state.element[listName].length) {
            this.state.element[listName].forEach((el) => {
                if (el.name === 'ALL' && el.selected) {
                    allSelected = true;
                }
            });
        }
        if (listName === 'petrols') {
            return (
                <div>
                    <div className={'row fleet-good-group'}>
                        {this.state.element[listName] && this.state.element[listName].length
                            ? this.state.element[listName].map((p, index) => {
                                  const color = p.color ? p.color : 'white';
                                  const fontColor = p.color ? 'white' : '#090E22';

                                  return (
                                      <InputCheckboxComponent
                                          key={`${p.name}-${listName}`}
                                          id={`${index}-${listName}`}
                                          name='selected'
                                          label={t(`products.${p.name}`)}
                                          labelOnRight
                                          value={p.selected}
                                          disabled={false}
                                          validator={this.validator}
                                          onChange={this.handleChange}
                                          viewMode={this.state.viewMode}
                                          validators='not_required'
                                          colClass='col-width-auto'
                                          stateField={`element.${listName}[${index}]`}
                                          grayBorder={false}
                                          transparentBorder
                                          labelClassName={`product-label card-details gray-border`}
                                          labelLeftStyle={{
                                              backgroundColor: `${color}`,
                                              color: `${fontColor}`,
                                              padding: '0 4px 0 4px',
                                              marginLeft: '8px',
                                              lineHeight: '24px',
                                              fontSize: '12px',
                                              height: '24px',
                                              marginBottom: 0,
                                          }}
                                          onAfterStateChange={() => {
                                              if (
                                                  (p.agreementTermPetraId !== null && p.selected === true) ||
                                                  (p.name === 'ALL' && p.selected === true)
                                              ) {
                                                  this.checkIfAgreementTermIsAlreadyAccepted(p);
                                              }
                                              this.setState((prevState) => {
                                                  const updatedElements = prevState.element[`${listName}`].map((item) => {
                                                      if (p.name === 'ALL' && p.selected === true) {
                                                          if (item.name !== 'ALL' && item.selected === false) {
                                                              return {...item, selected: true};
                                                          }
                                                      }
                                                      if (p.name === 'ALL' && p.selected === false) {
                                                          if (item.name !== 'ALL' && item.selected === true) {
                                                              return {...item, selected: false};
                                                          }
                                                      }
                                                      if (p.name !== 'ALL' && p.selected === false) {
                                                          if (item.name === 'ALL' && item.selected === true) {
                                                              return {...item, selected: false};
                                                          }
                                                      }
                                                      if (p.name !== 'ALL' && p.selected === true) {
                                                          const elementsWithSelectedTrue = prevState.element[`${listName}`].filter(
                                                              (element) => element.selected === true
                                                          );
                                                          const allSelected =
                                                              elementsWithSelectedTrue.length ===
                                                              prevState.element[`${listName}`].length - 1;
                                                          if (allSelected && item.name === 'ALL' && item.selected === false) {
                                                              return {...item, selected: true};
                                                          }
                                                      }
                                                      return item;
                                                  });
                                                  return {
                                                      element: {
                                                          ...prevState.element,
                                                          [listName]: updatedElements,
                                                      },
                                                  };
                                              });
                                          }}
                                      />
                                  );
                              })
                            : null}
                    </div>
                    <div className={'row fleet-good-group-banner-fuels'}>
                    {this.props.plasticCard && this.state.element[`petrols`].filter((n) => n.name === 'EV')[0]?.selected ? (
                        this.authService.getProfile().agreementType === 'CASH'?
                        <BannerComponent
                            key={'header-banner'}
                            label={t('cards.bannerEvDetailsCashClient')}
                            iconSvg='ico_red_banner_alert_icon'
                            iconSide='left'
                            variant='red-banner'
                        ></BannerComponent> :
                        <BannerComponent
                        key={'header-banner'}
                        label={t('cards.bannerEvDetails')}
                        iconSvg='ico_red_banner_alert_icon'
                        iconSide='left'
                        variant='red-banner'
                    ></BannerComponent>
                    ) : null}
                    </div>
                </div>
            );
        } else {
            return (
                <div className={'row product-not-fuel-label'}>
                    {this.state.element[listName] && this.state.element[listName].length
                        ? this.state.element[listName].map((p, index) => {
                              const color = p.color ? p.color : 'white';
                              const fontColor = p.color ? 'white' : '#090E22';
                              return (
                                  <InputCheckboxComponent
                                      key={`${p.name}-${listName}`}
                                      id={`${index}-${listName}`}
                                      name='selected'
                                      label={t(`products.${p.name}`)}
                                      labelOnRight
                                      value={p.selected || allSelected}
                                      disabled={allSelected && p.name !== 'ALL'}
                                      validator={this.validator}
                                      onChange={this.handleChange}
                                      viewMode={this.state.viewMode}
                                      validators='not_required'
                                      colClass='col-width-auto'
                                      stateField={`element.${listName}[${index}]`}
                                      grayBorder={false}
                                      transparentBorder
                                      labelClassName={`product-label card-details gray-border`}
                                      labelLeftStyle={{
                                          backgroundColor: `${color}`,
                                          color: `${fontColor}`,
                                          padding: '0 4px 0 4px',
                                          marginLeft: '8px',
                                          lineHeight: '24px',
                                          fontSize: '12px',
                                          height: '24px',
                                          marginBottom: 0,
                                      }}
                                  />
                              );
                          })
                        : null}
                </div>
            );
        }
    }

    renderFleetGoodGroupLimit(effectiveActiveIndex, limitType) {
        const {t} = this.props;
        let limitName;
        if (effectiveActiveIndex === 0) {
            if (limitType === 'quantityLimit') {
                limitName = 'fuelQuantityLimit';
            } else if (limitType === 'amountLimit') {
                limitName = 'fuelAmountLimit';
            }
        } else if (effectiveActiveIndex === 2) {
            limitName = 'notFuelAmountLimit';
            limitType = 'amountLimit';
        } else if (effectiveActiveIndex === 1) {
            limitName = 'serviceAmountLimit';
            limitType = 'amountLimit';
        }
        return !!this.state.element[limitName] ? (
            <React.Fragment>
                <InputCheckboxComponent
                    id={`${limitName}-limit-exist`}
                    name={'limit-exist'}
                    label={t(`cards.${limitType}`)}
                    labelOnRight
                    value={!!this.state.element[limitName].type}
                    validator={this.validator}
                    onChange={(type, params, event) => {
                        let element = this.state.element;
                        if (event.checked) {
                            element[limitName].type = 'DAILY';
                            element[limitName].value = 0;
                        } else {
                            element[limitName].type = undefined;
                            element[limitName].value = undefined;
                        }
                        this.setState({
                            element,
                        });
                    }}
                    viewMode={this.state.viewMode}
                    validators='not_required'
                    colClass='col-12'
                />
                <React.Fragment>
                    <InputRadioButtonComponent
                        id={`${limitName}-type`}
                        name='type'
                        colClass='col-12 card-manage-limits'
                        viewMode='EDIT'
                        options={[
                            {enumValue: 'DAILY', label: t('cards.daily')},
                            {enumValue: 'MONTHLY', label: t('cards.monthly')},
                        ]}
                        value={this.state.element[limitName].type}
                        valueLabel='label'
                        labelOnRight
                        itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                        onChange={this.handleChange}
                        showLabel={false}
                        validator={this.validator}
                        validators='required'
                        label={t('cards.timeTypeLabel')}
                        rendered={!!this.state.element[limitName].type}
                        valueKey='enumValue'
                        stateField={`element.${limitName}`}
                    />
                    <InputNumberComponent
                        id={`${limitName}-value`}
                        name='value'
                        label={t(`cards.${limitType}`)}
                        value={this.state.element[limitName].value}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        min={0}
                        inputStyle={{width: '100%'}}
                        colClass='col-12'
                        rendered={!!this.state.element[limitName].type}
                        placeholder={'0'}
                        stateField={`element.${limitName}`}
                    />
                    <div className={'fleet-good-group-banner-limits-dialog'}>
                <BannerComponent
                    key={'header-banner'}
                    label={t('cards.limitForEvOnlyMoreInfo')}
                    iconSvg='ico_blue_banner_icon'
                    className='row row-32'
                    iconSide='left'
                    rendered={ this.state.element[`petrols`].filter((n) => n.name === 'EV')[0]?.selected && limitType === 'quantityLimit'}
                    variant='blue-banner'
                ></BannerComponent>
                </div>
                </React.Fragment>
            </React.Fragment>
        ) : null;
    }

    renderDetails() {
        const {t, activeIndex} = this.props;
        const stateActiveIndex = this.state.activeIndex;
        const effectiveActiveIndex = isNaN(activeIndex) ? (isNaN(stateActiveIndex) ? 0 : stateActiveIndex) : activeIndex;
        return (
            <React.Fragment>
                {activeIndex === undefined || activeIndex === null ? (
                    <React.Fragment>
                        <div className='row'>
                            <InputNumberComponent
                                id={'monthlyAmountLimit'}
                                name={'monthlyAmountLimit'}
                                label={t('order-card.monthlyAmountLimitSummary')}
                                value={this.state.element.monthlyAmountLimit}
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                viewMode={'EDIT'}
                                min={0}
                                inputStyle={{width: '100%'}}
                                colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'
                            />
                            <InputNumberComponent
                                id={'dailyVisitLimit'}
                                name={'dailyVisitLimit'}
                                label={t('cards.dailyVisitLimit')}
                                value={this.state.element.dailyVisitLimit}
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                viewMode={'EDIT'}
                                min={0}
                                inputStyle={{width: '100%'}}
                                colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'
                            />
                        </div>
                        <DivContainer colClass='row'>
                            <TabView
                                className='card-manage-tab-view'
                                activeIndex={this.state.activeIndex}
                                onTabChange={this.handleTabChange}
                            >
                                <TabPanel header={`${t('cards.petrolHeader')}`}> {this.renderItems('petrols')}</TabPanel>
                                <TabPanel header={`${t('cards.serviceHeader')}`}> {this.renderItems('services')}</TabPanel>
                                <TabPanel header={`${t('cards.productsHeader')}`}> {this.renderItems('products')}</TabPanel>
                            </TabView>
                        </DivContainer>
                    </React.Fragment>
                ) : activeIndex === 0 ? (
                    this.renderItems('petrols')
                ) : activeIndex === 1 ? (
                    this.renderItems('services')
                ) : activeIndex === 2 ? (
                    this.renderItems('products')
                ) : null}

                <DivContainer colClass='row'>
                    <label className='limits-label'>{t('cards.limits')}</label>
                    {effectiveActiveIndex === 0 ? (
                        <div className='col-xxl-5 col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                            {this.renderFleetGoodGroupLimit(effectiveActiveIndex, 'quantityLimit')}
                        </div>
                    ) : null}
                    <div className='col-xxl-5 col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                        {this.renderFleetGoodGroupLimit(effectiveActiveIndex, 'amountLimit')}
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }
}

CardManageDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
};

CardManageDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    stationId: PropTypes.number,
};

export default withTranslation()(CardManageDialog);
